// extracted by mini-css-extract-plugin
module.exports = {"color":"SideBar_color__2BI1A","fix":"SideBar_fix__2Si_S","color1":"SideBar_color1__DTYjg","color3":"SideBar_color3___cOtF"};